var exports = {
  "Pc": "TagListField.module__tagsContainer___WXMzZ3",
  "Pr": "TagListField.module__tagsHeader___WXMzZ3",
  "cm": "TagListField.module__tagsLabel___WXMzZ3",
  "jw": "TagListField.module__tagInputRow___WXMzZ3",
  "Cs": "TagListField.module__tagsList___WXMzZ3",
  "Tc": "TagListField.module__tag___WXMzZ3",
  "xH": "TagListField.module__tagRemoveButton___WXMzZ3",
};

module.exports = exports;
